import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const CopilotPreviewHeader = ({
  previewTitle
}) => {
  return /*#__PURE__*/_jsx(Text, {
    as: "div",
    typography: "heading-25",
    truncate: true,
    children: previewTitle || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "aiAddonCopilotPreview.components.copilotPreview.summaryTitle"
    })
  });
};
export default CopilotPreviewHeader;